<template >
  <div class="bg-sub2">
    <div class="header-page-sub  container">
      <div class="" >
        <h4 class="header-history" v-if="result !== 0">{{title}}</h4>
        <div class="" v-for="sub in category"  v-if="sub.videos.length !== 0">
          <div class="">
            <h5 class="header-subtitle"><fa class="icon-sub" icon="minus" /> {{sub.name}}</h5>
          </div>
            <div class="recommended-content" >
              <section class="cards" >
                <div class="card-recommended" v-for="video in sub.videos" >
                    <router-link :to="'/vodpublic/' + video._id" >
                    <div class="" @click="PlayViewmoreCategory(video._id)">
                      <div class="preview-video">
                        <figure class="sixteen-nine-img">
                          <div class="btn-overlay-cate">
                            <fa icon="play" class="icon-play"/>
                          </div>
                          <img v-if="ThumborUse == false" :src="Thumb + '/' + video.thumb" />
                          <img v-if="ThumborUse == true" :src="Thumbor+'/unsafe/365x213/'+encodeURIComponent(Thumb+'/'+video.thumb)"/>
                          <p class="duration">{{video.duration}}</p>
                        </figure>
                      </div>
                      <div class="card-content">
                        <p class="card-title">{{video.name}}</p>
                        <p class="card-date">ดูทั้งหมด {{Number(video.views).toLocaleString()}} คน</p>
                        <p class="card-desc">{{video.desc}}</p>
                      </div>
                    </div>
                  </router-link>
                    
                  
                  <!--div class="function">
                    <btn class="btn-fav" type="submit" name="button"  @click="FunctionFavorite(item)">
                      <fa icon="heart" class="" v-bind:class="[FavoriteActive(item.favorite) ? 'icon-fav' : 'icon-fav2']"/>
                    </btn>
                    <btn class="btn-history" type="submit" name="button" @click="AddWatchLater(item)"><fa icon="history" class="icon-history" /></btn>
                    <btn class="btn-share" type="submit" name="button" @click.native="modalShare = true" @click="ShareLink(item)"><fa icon="share" class="icon-share"/></btn>
                  </div-->
                </div>
              </section>
              <!-- <jw-pagination :items="sub.videos" @changePage="onChangePage"></jw-pagination> -->
            </div>
            
        </div>
        
      </div>

      <div class="container notfound text-center" v-if="result == 0">
        <img src="../../src/assets/img/finallogo.png" alt="" class="img-category">
        <h3 class="text-category">ไม่มีวีดีโอในหมวดหมู่นี้</h3>
      </div>
    </div>
  </div>

</template>

<script>
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
const Thumb = config.app.Thumb;
const Thumbor = config.app.Thumbor;
const ThumborUse = config.app.ThumborUse;
import {
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  Btn,
  Fa,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter
} from 'mdbvue';

export default {
  name: 'ViewmoreCategoryPublicPage',
  components: {
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    Btn,
    Fa,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter
  },
  data() {
    return {
      Thumbor: '',
      ThumborUse: false,
      Link: '',
      modalShare: false,
      category: [],
      title: '',
      result: '',
      pageOfItems: []
    };
  },
  mounted() {
    //this.ToggleLogin();
    localStorage.pincode = '';
    //this.Session();
    this.feedCategory();
    this.feedSubCategory();
    this.Thumbor = Thumbor;
    this.ThumborUse = ThumborUse;
  },
  methods: {
    onChangePage(pageOfItems) {
      console.log(pageOfItems);
      
      this.pageOfItems = pageOfItems;
    },
    PlayViewmoreCategory(id) {
      document.location.assign('/#/vodpublic/' + id);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession , {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
    feedCategory() {
      let categoryid = this.$route.params.data;
      let APIgetCategory = Host + '/api/v1/category/video';
      axios.post(APIgetCategory , {
        category: categoryid
      }).then(response => {
        this.result = response.data.result.length;
        this.title = response.data.category;
      });
    },
    feedSubCategory() {
      let categoryid = this.$route.params.data;
      let APIgetCategory = Host + '/api/v1/subcategory/video/all';
      axios.post(APIgetCategory , {
        category: categoryid
      }).then(response => {
        this.Thumb = Thumb;
        this.category = response.data.result;
      });
    },
    ToggleLogin() {
      if (localStorage.auth == 'false' || !localStorage.auth) {
        this.$router.push('/');
      }
      this.modalLogin = true;
    }
  },
  watch: {
    '$route'(to, from) {
      this.feedCategory();
      this.feedSubCategory();
    }
  }
};
</script>

<style lang="css">
</style>
